export const NOTE_VIEW = "/note"
export const NEW_NOTE_VIEW = "/note/new"
export const NOTES_LIST_VIEW = "/notes"
